import createSagaMiddleware from 'redux-saga'

export const sagaMiddleware = createSagaMiddleware()

// Assign the array to a variable first
const middlewares = [sagaMiddleware];

export default middlewares;